module.exports = __webpack_public_path__ + "img/notasCredito.74faf823.svg";